import React from 'react';
// Components
import MainGalleryComponent from './MainGalleryComponent';

function GalleryPageMainContainer() {
  return (
    <main role='main' className='pb-12 pt-28 grid full_shadow_black_invert'>
      {/* Gallery Component */}
      <MainGalleryComponent />
    </main>
  );
}

export default GalleryPageMainContainer;
